/** Canonical community sports — stored Title Case on `communities.sport`. */

export const COMMUNITY_SPORT_OPTIONS = [
  { id: 'football', label: 'Football' },
  { id: 'basketball', label: 'Basketball' },
  { id: 'padel', label: 'Padel' },
]

export const COMMUNITY_SPORT_LABELS = COMMUNITY_SPORT_OPTIONS.map((o) => o.label)

/** Sports offered when an admin creates an academy or community. */
export const ADMIN_ORG_SPORT_LABELS = ['Football', 'Basketball']

export function normalizeCommunitySportId(raw) {
  const s = String(raw || '').trim().toLowerCase()
  if (s.includes('basketball')) return 'basketball'
  if (s.includes('padel')) return 'padel'
  if (s.includes('football') || s.includes('soccer')) return 'football'
  return 'football'
}

export function communitySportLabel(raw) {
  const id = normalizeCommunitySportId(raw)
  return COMMUNITY_SPORT_OPTIONS.find((o) => o.id === id)?.label || 'Football'
}

/** Games.sport is stored Title Case (Football, Basketball, Padel). */
export function formatGameSportForDb(raw) {
  const trimmed = String(raw || '').trim()
  if (!trimmed) return ''
  return communitySportLabel(trimmed)
}

export function communitySportEmoji(raw) {
  const id = normalizeCommunitySportId(raw)
  if (id === 'basketball') return '🏀'
  if (id === 'padel') return '🎾'
  return '⚽'
}

export function formatCommunitySportDisplay(raw) {
  return `${communitySportEmoji(raw)} ${communitySportLabel(raw)}`
}

export function isBasketballSport(raw) {
  return normalizeCommunitySportId(raw) === 'basketball'
}

export function isPadelSport(raw) {
  return normalizeCommunitySportId(raw) === 'padel'
}
